import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import PageHero from '../evenementielle/components/PageHero';
import InterieurServicesGrid from './components/InterieurServicesGrid';
import BeforeAfterGallery from './components/BeforeAfterGallery';
import InterieurCta from './components/InterieurCta';

const InterieurIntro = () => (
  <section className="bg-white py-16 px-6">
    <div className="max-w-4xl mx-auto text-center">
      <p className="font-serif text-xl lg:text-2xl text-brand-anthracite leading-relaxed italic">
        "Aménagez votre intérieur avec style et harmonie."
      </p>
      <div className="h-px w-24 bg-brand-gold mx-auto mt-6" />
    </div>
  </section>
);

const InterieurPage = () => (
  <>
    <title>Décoration Intérieur Abidjan | Aménagement & Conception 3D | Ev & Co Design</title>
    <meta name="description" content="Aménagement intérieur haut de gamme à Abidjan : conception 3D, conseil en aménagement, mobilier sur mesure. Transformez votre espace avec Ev & Co Design, Côte d'Ivoire." />
    <meta name="keywords" content="décoration intérieur Abidjan, aménagement espace Côte d'Ivoire, mobilier sur mesure Abidjan" />
    <link rel="canonical" href="https://evcodesign-ci.com/decoration-interieur" />
    <meta property="og:title" content="Décoration d'Intérieur Abidjan | Ev & Co Design" />
    <meta property="og:description" content="Aménagez votre intérieur avec style et harmonie. Conception 3D, conseil et mobilier sur mesure à Abidjan." />
    <main className="font-sans bg-brand-beige min-h-screen">
      <Navbar />
      <PageHero
        title="Décoration d'Intérieur"
        subtitle="Transformez vos espaces résidentiels et professionnels en environnements élégants, fonctionnels et inspirants."
        image="https://readdy.ai/api/search-image?query=luxury%20modern%20interior%20design%20living%20room%20Abidjan%20Africa%20elegant%20sophisticated%20neutral%20beige%20cream%20tones%20gold%20accents%20contemporary%20furniture%20high%20end%20residential%20beautiful%20light&width=1920&height=800&seq=evco_inthero001&orientation=landscape"
        imageAlt="Décoration intérieure Abidjan"
        breadcrumb="Décoration d'Intérieur"
      />
      <InterieurIntro />
      <InterieurServicesGrid />
      <BeforeAfterGallery />
      <InterieurCta />
      <Footer />
    </main>
  </>
);

export default InterieurPage;
